<!-- TODO: Make sense to refactor it -->

<div class="container" id="spinerLoader" *ngIf="loader">
  <div class="loader">Loading...</div>
</div>

<header class="main-header">
  <!-- Header Navbar: style can be found in header.less -->
  <nav class="navbar">
    <div class="mb-0" id="userMenu">
      <div class="d-flex justify-content-end temp-header-container">
        <ng-container *ngIf="isShowCreateServiceRequestButton && isCustomerRole">
          <button mat-button class="btn-csr" (click)="onCreateServiceRequest()"><mat-icon>add</mat-icon>SERVICE REQUEST</button>
        </ng-container>

        <div class="timeZone align-self-center">
          <ngx-select-dropdown tabindex="0"
                               [multiple]="false"
                               name="timeZone"
                               class="time-zone-dropdown"
                               id="timeZoneDropDown"
                               (change)="selectTimezone($event)"
                               [config]="timezoneConfig"
                               [options]="timezones"
                               [(ngModel)]="selectedTimezone"
                               (click)="clickDropDown('timeZoneDropDown')"
                               [disabled]="isTimeZoneLock || (currentActivePage == 'Customer Dashboard' && user.role == 'Management')"
                               [class.cursorDisabled]="isTimeZoneLock || (currentActivePage == 'Customer Dashboard' && user.role == 'Management')"
          >
          </ngx-select-dropdown>
        </div>

        <div class="d-flex flex-header-buttons">
          <button mat-mini-fab class="tac-fab-black downloadUI" (click)="download()" *ngIf="isDownloadButtonShow==true" title="Download UI">
            <mat-icon>download</mat-icon>
          </button>

          <button mat-mini-fab class="tac-fab-black" *ngIf="!isInternalReadOnly" [routerLink]="['/group-chat']" title="Group Chat">
            <mat-icon>forum</mat-icon>
          </button>

          <span class="leg-detail-dot status-dot m-0" *ngIf="incomingMessage!=0 && (user.role == 'Executive Admin' ||  user.role == 'Coordinator' || user.role == 'Management')" style="position: relative;right: 13px !important; bottom: 12px !important;">
            {{incomingMessage}}
          </span>
        </div>
        <app-notifications *ngIf="isShowNotificationButton" class="notifications"></app-notifications>
        <div class="flex-center">
          <div [matMenuTriggerFor]="menu" (menuClosed)="clickUserDropDownClose(); isUserDropDownopen = false" (menuOpened)="clickUserDropDownOpen(); isUserDropDownopen = true">
            <a href="#" class="dropdown-toggle icon_profile rounded_profile_icon"
              style="float: right; text-decoration: none; padding:0px;" data-toggle="dropdown">
              <div *ngIf="!isCurrentUserPicture" class="user-initial user-logo" [class.active]="isUserDropDownopen">{{userAbbreviation}}</div>
              <img *ngIf="isCurrentUserPicture" class="user-logo" [class.active]="isUserDropDownopen" [src]="currentUserPicture"
                class="img-circle headerProfileIcon" alt="User Image" style="height: 45px;width:45px;" />
            </a>
          </div>
          <mat-menu #menu="matMenu" class="member_menu"> 
            <div class="profile_submenu">
              <div class="user-panel">
                <div class="user-header d-flex border-none">
                  <div *ngIf="!isCurrentUserPicture" class="user-initial">{{userAbbreviation}}</div>
                  <img *ngIf="isCurrentUserPicture" [src]="currentUserPicture"
                    class="img-circle user-image-size d-flex ml-3 align-self-center" alt="User Image" />
                  <div class="d-flex user-info">
                    <div class="user-name">{{user.name}}</div>
                    <span>Role: {{user.role}}</span>
                    <span>Org: {{user.businessUnitName}}</span>
                  </div>
                </div>
                <ng-container *ngIf="user && user.assignedRoleList && user.assignedRoleList.length > 1">
                  <div class="role-block">
                    <div class="role-block__title">My roles (click to switch)</div>
                    <div class="role-block__item" [class.active]="user.roleId == role.roleId" *ngFor="let role of user.assignedRoleList">
                      <mat-radio-group>
                        <mat-radio-button
                          [checked]="user.roleId === role.roleId" 
                          [value]="role.roleId"
                          (change)="switchRole(role)"
                          >{{ role.roleName }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="user && user.businessUnitList && user.businessUnitList.length">
                  <div class="role-block">
                    <div class="role-block__title">My organization (click to switch)</div>
                    <div class="role-block__item" [class.active]="user.businessUnitId == org.id" *ngFor="let org of user.businessUnitList">
                      <mat-radio-group>
                        <mat-radio-button
                          [checked]="user.businessUnitId === org.id" 
                          [value]="org.id"
                          (change)="switchOrganization(org)"
                          >{{ org.name }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </ng-container>
                <div class="user-footer">
                  <div class="user-footer__link border">
                    <a class="user-footer__link-text" [routerLink]="['/v2/profile']">
                      <img src="assets/icons/v2/user.svg" alt="">
                      <span>View Profile</span>
                    </a>
                  </div>
                  <div class="user-footer__link logout" (click)="signOut()">
                    <img src="assets/icons/v2/logout.svg" alt="">
                    <span>Log out</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>
  </nav>
</header>

<app-header-mobile class="header-mobile" [(isMenuOpen)]="isMenuOpen" (isMenuOpenChange)="isMenuOpenChange.emit(isMenuOpen)"></app-header-mobile>
